// extracted by mini-css-extract-plugin
module.exports = {"bgTop":"resources-module--bgTop--30usI"};